import React from 'react';
import { useTour } from '../../contexts/TourContext';
import './TourStep.css';

const TourStep: React.FC = () => {
  const { state, completeStep, completeTour, setState } = useTour();
  const { currentStep } = state;

  const handleNext = async () => {
    console.log('🔄 handleNext aufgerufen für Schritt:', currentStep);
    console.log('🔄 Aktueller State:', state);
    
    if (currentStep === 6) {
      // Letzter Schritt - Tour abschließen
      try {
        console.log('🏁 Letzter Schritt - schließe Tour ab');
        console.log('🏁 Rufe completeTour() auf...');
        const result = await completeTour();
        console.log('🏁 completeTour() Ergebnis:', result);
        
        if (result) {
          console.log('✅ Tour erfolgreich abgeschlossen - Modal wird geschlossen');
          // Tour erfolgreich abgeschlossen - das Modal wird automatisch geschlossen
          // Keine Weiterleitung nötig, da die Tour bereits deaktiviert wurde
        } else {
          console.error('❌ Tour konnte nicht abgeschlossen werden');
        }
      } catch (error) {
        console.error('❌ Fehler beim Abschließen der Tour:', error);
      }
    } else {
      console.log('🔄 Rufe completeStep auf mit step:', currentStep);
      console.log('🔄 Erwarteter nächster Schritt:', currentStep + 1);
      // completeStep setzt currentStep auf step + 1, also rufe es mit currentStep auf
      completeStep(currentStep);
      console.log('✅ completeStep aufgerufen');
    }
  };

  const handleBack = () => {
    if (currentStep > 1) {
      console.log('🔄 Gehe zurück zu Schritt:', currentStep - 1);
      // Direkt den State setzen statt completeStep zu verwenden
      const newState = {
        ...state,
        currentStep: currentStep - 1,
      };
      setState(newState);
      localStorage.setItem('tourState', JSON.stringify(newState));
      console.log('✅ Zurück zu Schritt:', currentStep - 1);
    }
  };

  const renderStepContent = () => {
    switch (currentStep) {
      case 1:
        return (
          <div className="tour-step-content">
            <h3>📱 PWA Installation</h3>
            <div className="tour-step-body">
              <p>AS Monitor kann als Progressive Web App (PWA) auf deinem Smartphone installiert werden:</p>
              <div className="tour-instructions">
                <div className="instruction-item">
                  <strong>iOS (Safari):</strong>
                  <ol>
                    <li>Tippe auf das "Teilen" Symbol (Quadrat mit Pfeil nach oben)</li>
                    <li>Wähle "Zum Home-Bildschirm hinzufügen"</li>
                    <li>Bestätige mit "Hinzufügen"</li>
                  </ol>
                </div>
                <div className="instruction-item">
                  <strong>Android (Chrome):</strong>
                  <ol>
                    <li>Tippe auf das Menü (drei Punkte)</li>
                    <li>Wähle "Zur Startseite hinzufügen" oder "App installieren"</li>
                    <li>Bestätige die Installation</li>
                  </ol>
                </div>
              </div>
              <p className="tour-tip">💡 <strong>Tipp:</strong> Die PWA funktioniert auch offline und bietet eine native App-Erfahrung!</p>
            </div>
          </div>
        );

      case 2:
        return (
          <div className="tour-step-content">
            <h3>🚨 Einsätze erstellen</h3>
            <div className="tour-step-body">
              <p>Einsätze können auf zwei Arten erstellt werden:</p>
              <div className="tour-features">
                <div className="feature-item">
                  <h4>📱 Direkt in der App</h4>
                  <p>Klicke auf "Neuer Einsatz" im Dashboard und fülle die Details aus.</p>
                </div>
                <div className="feature-item">
                  <h4>🌐 Über FireHub</h4>
                  <p>Einsätze können auch automatisch über die Lösung <a href="https://www.firehub.ch" target="_blank" rel="noopener noreferrer">FireHub</a> importiert werden. Das spart Zeit und du hast deine Einsätze direkt automatisiert in deinem System.</p>
                </div>
              </div>
              <p className="tour-tip">💡 <strong>Tipp:</strong> FireHub bietet erweiterte Funktionen für die Einsatzplanung!</p>
            </div>
          </div>
        );

      case 3:
        return (
          <div className="tour-step-content">
            <h3>👥 Truppen erfassen</h3>
            <div className="tour-step-body">
              <p>In einem Einsatz kannst du Truppen hinzufügen und verwalten:</p>
              <div className="tour-instructions">
                <ol>
                  <li><strong>Trupp hinzufügen:</strong> Klicke auf das "+" Symbol im Einsatz</li>
                  <li><strong>Mitglieder hinzufügen:</strong> Füge Truppführer und Truppmitglieder hinzu</li>
                  <li><strong>NFC-Scanner:</strong> Nutze den NFC-Scanner für schnelle Erfassung</li>
                  <li><strong>Status verwalten:</strong> Verfolge den Status jedes Trupps in Echtzeit</li>
                </ol>
              </div>
              <p className="tour-tip">💡 <strong>Tipp:</strong> Nutze NFC-Tags für noch schnellere Trupp-Erfassung!</p>
            </div>
          </div>
        );

      case 4:
        return (
          <div className="tour-step-content">
            <h3>👨‍💼 Einsatzleitermodus</h3>
            <div className="tour-step-body">
              <p>Der Einsatzleitermodus bietet erweiterte Funktionen für Einsatzleiter:</p>
              <div className="tour-features">
                <div className="feature-item">
                  <h4>🌐 Alle Truppen sehen</h4>
                  <p>Im Einsatzleitermodus siehst du alle Truppen der Organisation, nicht nur deine eigenen.</p>
                </div>
                <div className="feature-item">
                  <h4>🔄 Automatische Synchronisation</h4>
                  <p>Daten werden automatisch mit dem Server synchronisiert.</p>
                </div>
                <div className="feature-item">
                  <h4>📊 Übersichtliche Darstellung</h4>
                  <p>Bessere Übersicht über alle aktiven Einsätze und Truppen.</p>
                </div>
              </div>
              <p className="tour-tip">💡 <strong>Tipp:</strong> Aktiviere den Einsatzleitermodus über das Menü!</p>
            </div>
          </div>
        );

      case 5:
        return (
          <div className="tour-step-content">
            <h3>📋 Auditlogs anzeigen</h3>
            <div className="tour-step-body">
              <p>Auditlogs zeigen alle Aktivitäten und Änderungen in einem Einsatz:</p>
              <div className="tour-instructions">
                <ol>
                  <li><strong>Info-Icon:</strong> Klicke auf das ℹ️ Symbol bei einem Trupp</li>
                  <li><strong>Auditlog anzeigen:</strong> Sieh alle Änderungen und Aktivitäten</li>
                  <li><strong>PDF-Export:</strong> Exportiere das Auditlog als PDF für Dokumentation</li>
                  <li><strong>Filter:</strong> Filtere nach Datum, Benutzer oder Aktivität</li>
                </ol>
              </div>
              <p className="tour-tip">💡 <strong>Tipp:</strong> Auditlogs sind wichtig für die Nachbereitung von Einsätzen!</p>
            </div>
          </div>
        );

      case 6:
        return (
          <div className="tour-step-content">
            <h3>🌐 Portal-Zugang</h3>
            <div className="tour-step-body">
              <p>Das AS Monitor Portal bietet erweiterte Funktionen:</p>
              <div className="tour-features">
                <div className="feature-item">
                  <h4>📊 Dashboard & Berichte</h4>
                  <p>Detaillierte Statistiken und Berichte über Einsätze und Truppen.</p>
                </div>
                <div className="feature-item">
                  <h4>👥 Benutzerverwaltung</h4>
                  <p>Verwalte Benutzer, Rollen und Berechtigungen.</p>
                </div>
                <div className="feature-item">
                  <h4>⚙️ Systemeinstellungen</h4>
                  <p>Konfiguriere Organisation, Einsatztypen und Standardwerte.</p>
                </div>
              </div>
              <p className="tour-tip">💡 <strong>Tipp:</strong> Das Portal ist über <a href="https://portal.as-monitor.ch" target="_blank" rel="noopener noreferrer">portal.as-monitor.ch</a> erreichbar!</p>
            </div>
          </div>
        );

      default:
        return (
          <div className="tour-step-content">
            <h3>🎉 Tour abgeschlossen!</h3>
            <div className="tour-step-body">
              <p>Herzlichen Glückwunsch! Du hast alle wichtigen Funktionen von AS Monitor kennengelernt.</p>
              <p>Du kannst jetzt:</p>
              <ul>
                <li>✅ Die App als PWA installieren</li>
                <li>✅ Einsätze erstellen und verwalten</li>
                <li>✅ Truppen erfassen und überwachen</li>
                <li>✅ Den Einsatzleitermodus nutzen</li>
                <li>✅ Auditlogs einsehen und exportieren</li>
                <li>✅ Das Portal für erweiterte Funktionen nutzen</li>
              </ul>
            </div>
          </div>
        );
    }
  };

  return (
    <div className="tour-step">
      {renderStepContent()}
      
      <div className="tour-navigation">
        <button 
          onClick={handleBack} 
          disabled={currentStep <= 1}
          className="tour-back-btn"
        >
          Zurück
        </button>
        
        <button 
          onClick={handleNext}
          className="tour-next-btn"
        >
          {currentStep >= 6 ? 'Tour abschliessen' : 'Weiter'}
        </button>
      </div>
    </div>
  );
};

export default TourStep;
